import type { User } from '@/types/api'
import { create } from 'zustand'

interface AuthState {
  token: string | null
  user: User | null
  setAuth: (token: string, user: User) => void
  logout: () => void
}

const storedToken = localStorage.getItem('admin_token')
const storedUserRaw = localStorage.getItem('admin_user')
const storedUser = storedUserRaw
  ? (JSON.parse(storedUserRaw) as User)
  : null

export const useAuthStore = create<AuthState>(set => ({
  token: storedToken,
  user: storedUser,
  setAuth: (token, user) => {
    localStorage.setItem('admin_token', token)
    localStorage.setItem('admin_user', JSON.stringify(user))
    set({ token, user })
  },
  logout: () => {
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_user')
    set({ token: null, user: null })
  },
}))
